import { MapRouterAction } from './actions';

export interface MapRouterState {
  path?: string;
}

export const mapRouterReducer = (state: MapRouterState = {}, action: MapRouterAction): MapRouterState => {
  if (action.type === 'navigate_map') {
    return { ...state, path: action.path };
  }
  return state;
};
